/* eslint-disable prettier/prettier */

import { TemplateSlugs } from './TemplateSlugs';

export function getTemplateName(): TemplateSlugs {
    return <TemplateSlugs>process.env.MIX_APP_TEMPLATE;
}

export function getTemplateBase(): TemplateSlugs {
    return <TemplateSlugs>process.env.MIX_TEMPLATE_BASE;
}

export const isZambia = function (): boolean {
    return getTemplateName() === TemplateSlugs.zambia;
};

export const isNigeria = function (): boolean {
    return getTemplateName() === TemplateSlugs.nigeria;
};

export const isPeru = function (): boolean {
    return getTemplateName() === TemplateSlugs.peru;
};

export const isHaiti = function (): boolean {
    return getTemplateName() === TemplateSlugs.haiti;
};

export const isKorsou = function (): boolean {
    return getTemplateName() === TemplateSlugs.korsou;
};

export const isGGWorld = function (): boolean {
    return getTemplateName() === TemplateSlugs.ggworld;
};

export const isMalawi = function (): boolean {
    return getTemplateName() === TemplateSlugs.malawi;
};

export const isPremierZambia = function (): boolean {
    return getTemplateName() === TemplateSlugs.premier_zambia;
};

export const isPremierPeru = function (): boolean {
    return getTemplateName() === TemplateSlugs.premier_peru;
};

export const isRcLotto = function (): boolean {
    return getTemplateName() === TemplateSlugs.rc_lotto;
};

export const isGuatemala = function (): boolean {
    return getTemplateName() === TemplateSlugs.guatemala;
};

export const is25Lotto = function (): boolean {
    return getTemplateName() === TemplateSlugs['25lotto'];
};

export const is25LottoKenya = function (): boolean {
    return getTemplateName() === TemplateSlugs['25lotto-kenya'];
};

export const isPremierMali = function (): boolean {
    return getTemplateName() === TemplateSlugs.premier_mali;
};

export const isPremierDubai = function (): boolean {
    return getTemplateName() === TemplateSlugs.premier_dubai;
};

export const isLotoCash = function (): boolean {
    return getTemplateName() === TemplateSlugs.lotocash;
};
export const isLottoPark = function (): boolean {
    return getTemplateName() === TemplateSlugs.lottopark;
};

export const isLottoAlmabet = function (): boolean {
    return getTemplateName() === TemplateSlugs.lotto_almabet;
};

export const isLttry = function (): boolean {
    return getTemplateName() === TemplateSlugs.lttry;
};

export const isLottoplayCoUk = function (): boolean {
    return getTemplateName() === TemplateSlugs.lottoplay_co_uk;
};

export const isLottoplayCoMx = function (): boolean {
    return getTemplateName() === TemplateSlugs.lottoplay_co_mx;
};

export const isLottoplayMGA = function (): boolean {
    return getTemplateName() === TemplateSlugs.lottoplay_mga;
};

export const isMML = function (): boolean {
    return getTemplateName() === TemplateSlugs.mml;
};

export const isArabia = function (): boolean {
    return getTemplateName() === TemplateSlugs.arabia;
};
export const isPlayport = function (): boolean {
    return getTemplateName() === TemplateSlugs.playport;
};

export const isBrasil = function (): boolean {
    return getTemplateName() === TemplateSlugs.brasil
}

export const isLottoAmerica = function (): boolean {
    return getTemplateName() === TemplateSlugs.america;
}
export const isGamesMillions = function (): boolean {
    return getTemplateName() === TemplateSlugs.games_millions;
}
export const isBig5Lottery = function (): boolean {
    return getTemplateName() === TemplateSlugs.big5lottery;
}

export const isDragonLotto24 = function (): boolean {
    return getTemplateName() === TemplateSlugs.dragonlotto24;
}
export const isThankYouLotto = function (): boolean {
    return getTemplateName() === TemplateSlugs.thankyoulotto;
}
export const isDotyCasino = function (): boolean {
    return getTemplateName() === TemplateSlugs.dotycasino;
}

export const isTemplateAlpha = function (): boolean {
    return [TemplateSlugs.zambia, TemplateSlugs.korsou].includes(getTemplateName());
};

export const isTemplateBeta = function (): boolean {
    return [
        TemplateSlugs.nigeria,
        TemplateSlugs.haiti,
        TemplateSlugs.peru,
        TemplateSlugs.rc_lotto,
        TemplateSlugs.guatemala,
        TemplateSlugs['25lotto'],
        TemplateSlugs.lotto_almabet,
        TemplateSlugs.america,
    ].includes(getTemplateName());
};

export const isTemplateGamma = function (): boolean {
    return isGGWorld();
};

export const isTemplateDelta = function (): boolean {
    return [
        TemplateSlugs.malawi,
        TemplateSlugs.congo,
        TemplateSlugs.cameroon,
        TemplateSlugs.chad,
        TemplateSlugs.rd_congo,
        TemplateSlugs.guinea,
        TemplateSlugs.mozambique,
        TemplateSlugs.sierra_leone,
        TemplateSlugs.bahrain,
        TemplateSlugs.kenya,
        TemplateSlugs.lotocash,
        TemplateSlugs.premier_zambia,
        TemplateSlugs.premier_peru,
        TemplateSlugs.premier_mali,
        TemplateSlugs.premier_dubai,
    ].includes(getTemplateName());
};

export const isTemplateZeta = function (): boolean {
    return [
        TemplateSlugs.lottopark,
        TemplateSlugs.lttry,
        TemplateSlugs.arabia,
        TemplateSlugs.brasil,
        TemplateSlugs.games_millions,
        TemplateSlugs.big5lottery,
        TemplateSlugs.dragonlotto24,
        TemplateSlugs.playlottoglobal,
        TemplateSlugs.surewinbd,
        TemplateSlugs.thankyoulotto,
    ].includes(getTemplateName());
};

export const isTemplateTheta = function (): boolean {
    return [
        TemplateSlugs.lottoplay_co_uk,
        TemplateSlugs.lottoplay_co_mx,
        TemplateSlugs.lottoplay_mga,
    ].includes(getTemplateName());
};

export const isTemplateWidget = function (): boolean {
    return [
        TemplateSlugs.widget_default
    ].includes(getTemplateName());
}

export const isCameroon = function (): boolean {
    return getTemplateName() === TemplateSlugs.cameroon;
};

export const isDefault = function (): boolean {
    return [
        TemplateSlugs.default
    ].includes(getTemplateBase());
}
